/**
 * ported from redux-notifications
 */
import { useDispatch, useSelector } from 'react-redux';
import { notifDismiss } from '../../actions/notifications';
import Notification from '../../molecules/Notification';
import { IStore } from '../../reducers';
import './styles.scss';

interface INotifProps {
  className?: string;
  componentClassName?: any;
  CustomComponent?: any;
}

const Notifs = (props: INotifProps) => {
  const notifications = useSelector((state: IStore) => state.notifs);
  const dispatch = useDispatch();

  const onClose = (id: string) =>
    dispatch(notifDismiss(id));

  const className = props.className || null;
  const componentClassName = props.componentClassName || 'notif';
  const CustomComponent = props.CustomComponent || null;

  return (
    <div className={`notif__container ${className}`}>
      {notifications.map((notification: any) => {
        const id = notification['id'];
        if (CustomComponent) {
          return (
            <CustomComponent
              {...props}
              componentClassName={componentClassName}
              key={id}
              id={id}
              message={notification['message']}
              kind={notification['kind']}
              onClose={() => onClose(id)}
            />
          );
        }
        return (
          <Notification
            variant={notification['kind']}
            key={id}
            id={id}
            text={notification['message']}
            onClose={() => onClose(id)}
          />
        );
      })}
    </div>
  );
};

export default Notifs;
